import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import { useCountries } from "../../../hooks/useData";
import { Drawer, Button as AntButton, Card, Select as AntSelect, DatePicker as AntDatePicker, Input as AntInput } from "antd";
import { SearchOutlined, AppleFilled, AndroidFilled } from "@ant-design/icons";
import dayjs from 'dayjs';


import Api from "../../../services/api";
// import DateComponent from "../../../components/datepicker";
// import InputComponent from "../../../components/input";
// import SelectComponent from "../../../components/select";
// import Select2Custom from "../../../components/Select2Custom";
// import SelectAdnetworkComponent from "../../../components/selectAdnetwork";
// import SelectAppsComponent from "../../../components/selectApp";
// import SelectOsComponent from "../../../components/selectOs";


import AppSumary from "./table/appSumary";
import AppNetwork from "./table/appNetwork";
import ChartPlatformCost from "./table/chartPlatformCost";
import ChartPlatformRevenue from "./table/chartPlatformRevenue";
import ChartCampaignTargetType from "./table/chartCampaignTargetType";
import ChartCountry from "./table/chartCountry";
import AppCampaignPerformance from "./table/appCampaignPerformance";
import AppAdPerformance from "./table/appAdPerformance";
import AppAssetPerformance from "./table/appAssetPerformance";
import AppAppPerformance from "./table/appAppPerformance";
import { END_DATE, START_DATE } from "../../../utility";
// import SelectAppsMultiComponent from "../../../components/selectAppMulti";


const FILTER_ADNETWORK = [
  { code: "cost", name: "Cost" },
  { code: "install", name: "Install" },
  { code: "ecpi", name: "Ecpi" },
  { code: "ecpm", name: "Ecpm" },
];

const FILTER_PLATFORM_COST = [
  { code: "cost", name: "Cost" },
  { code: "install", name: "Install" },
];

const FILTER_REVENUE = [
  { code: "revenue", name: "Revenue" },
  { code: "ad_revenue", name: "Ad revenue" },
  { code: "iap_revenue", name: "IAP revenue" },
];


const SORT_BY_OPTIONS = [
  { code: "value", name: "Sort By Value" },
  { code: "change", name: "Sort By Change" },
];

function Dashboard() {
  const navigate = useNavigate();
  const { countries } = useCountries();
  const [appsOptions, setAppsOptions] = useState([]);
  const [adNetworkOptions, setAdNetworkOptions] = useState([]);
  // Chuẩn hoá dữ liệu country cho Antd Select (hỗ trợ cả {code,name} và {value,label})
  const countryOptions = (countries || []).map((c) => ({
    value: c?.value ?? c?.code,
    label: c?.label ?? c?.name,
  }));

  // Options cho OS với icon
  const osOptions = [
    { 
      value: "ios", 
      label: (
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <AppleFilled style={{ fontSize: 16 }} />
          <span>iOS</span>
        </span>
      )
    },
    { 
      value: "android", 
      label: (
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <AndroidFilled style={{ fontSize: 16 }} />
          <span>Android</span>
        </span>
      )
    },
  ];

  const [filters, setFilters] = useState({
    startDate: moment().subtract(START_DATE, "days"),
    endDate: moment().subtract(END_DATE, "days"),
    campaign: "",
    country: "",
    adnetwork: "",
    code: [],
    option: [],
    os: "",
  });

  const [chartTypes, setChartTypes] = useState({
    platformCost: "cost",
    platformRevenue: "revenue",
    country: "cost",
    campaignTargetType: "cost",
    typeAdnetwork: "cost",
    typeRetention: 1,
  });

  const [sortOptions, setSortOptions] = useState({
    campaign: "value",
    ad: "value",
    assetPer: "value",
    appPer: "value",
  });

  const [load, setLoad] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    // Countries data is now loaded automatically via useCountries hook

    const parseUrlParams = () => {
      const params = new URLSearchParams(window.location.search);
      const newFilters = { ...filters };

      if (params.get("startDate"))
        newFilters.startDate = moment(params.get("startDate"));
      if (params.get("endDate"))
        newFilters.endDate = moment(params.get("endDate"));
      if (params.get("campaign")) newFilters.campaign = params.get("campaign");
      if (params.get("country")) newFilters.country = params.get("country");
      if (params.get("adnetwork"))
        newFilters.adnetwork = params.get("adnetwork");
      
      if (params.get("code")) {
        const codeParam = params.get("code");
        const codeArray = codeParam.split(",");
        newFilters.code = codeArray;
        
        newFilters.option = codeArray.map(code => ({
          value: code,
          label: code
        }));
      }
      
      if (params.get("os")) newFilters.os = params.get("os");

      setFilters(newFilters);
    };

    parseUrlParams();
    // Load apps list for Select options
    (async () => {
      try {
        const res = await Api.get("/api/app_list");
        const items = (res?.data?.data) || [];
        // Gộp theo code: ưu tiên bản android nếu có, nếu không thì lấy bản đầu tiên
        const codeToApp = new Map();
        for (const app of items) {
          const exist = codeToApp.get(app.code);
          if (!exist) {
            codeToApp.set(app.code, app);
          } else if (exist.os !== 'android' && app.os === 'android') {
            codeToApp.set(app.code, app);
          }
        }

        const opts = Array.from(codeToApp.values()).map((app) => ({
          value: app.code,
          // label chỉ gồm ảnh + code theo yêu cầu (ảnh 32px)
          label: (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <img src={app.thumb} alt={app.code} style={{ width: 22, height: 22, borderRadius: 4, objectFit: 'cover' }} />
              <span style={{ fontWeight: 400 }}>{app.code}</span>
            </div>
          )
        }));
        setAppsOptions(opts);
      } catch (e) {
        toast.error("Không tải được danh sách Apps");
      }
    })();

    // Load ad networks list from API
    (async () => {
      try {
        const res = await Api.get("/api/filter/ad_network");
        const raw = Array.isArray(res?.data?.data) ? res.data.data : [];
        const opts = raw.map((n) => {
          const code = n.code || '';
          const name = n.name || n.code || '';
          const icon = n.icon || '';
          return {
            value: code,
            label: (
              <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {icon && (
                  <img
                    src={icon}
                    alt={name}
                    style={{ width: 16, height: 16, objectFit: 'contain' }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                )}
                <span>{name}</span>
              </span>
            )
          };
        });
        setAdNetworkOptions(opts);
      } catch (e) {
        toast.error("Không tải được danh sách Ad Networks");
        // Fallback to default options if API fails
        setAdNetworkOptions([
          { value: "googleads", label: "Google Ads" },
          { value: "facebook", label: "Facebook" },
          { value: "tiktok", label: "TikTok" },
        ]);
      }
    })();
  }, []);

  const handleApplyFilters = () => {
    // Close drawer on mobile
    setDrawerOpen(false);
    
    const queryParams = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if(key !== 'option'){
        if (value && key === "startDate")
          queryParams.append(key, moment(value).format("YYYY-MM-DD"));
        else if (value && key === "endDate")
          queryParams.append(key, moment(value).format("YYYY-MM-DD"));
        else if (value) queryParams.append(key, value);
      }
    });

    navigate(`?${queryParams.toString()}`, { replace: true });

    setLoad((prev) => !prev);
  };

  
  const handleResetFilters = () => {
    // Close drawer on mobile
    setDrawerOpen(false);
    
    setFilters({
      startDate: moment().subtract(START_DATE, "days"),
      endDate: moment().subtract(END_DATE, "days"),
      campaign: "",
      country: "",
      adnetwork: "",
      code: [],
      option: [],
      os: "",
    });

    navigate("", { replace: true });
    setLoad((prev) => !prev);
  };

  
  const handleChangeDate = (event, picker) => {
    setFilters((prev) => ({
      ...prev,
      startDate: picker.startDate,
      endDate: picker.endDate,
    }));
  };

  
  const handleChangeApp = (selectedOptions) => {
    setFilters((prev) => ({
      ...prev,
      option: selectedOptions,
      code: selectedOptions.map(option => option.value),
    }));
  };

  return (
    <div className="background-second dashboard-scope">
      {/* Mobile: Search icon button - outside main__filter to always show */}
      { !drawerOpen && (
        <div className="mobile-search-toggle" style={{ 
          display: 'none',
          position: 'fixed',
          right: '16px',
          top: '54px',
          zIndex: 1002,
        }}>
          <AntButton
            type="primary"
            icon={<SearchOutlined />}
            onClick={() => setDrawerOpen(true)}
            style={{
              borderRadius: '50%',
              width: '48px',
              height: '48px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              position: 'relative'
            }}
          />
        </div>
      )}
      
      <section className="main__filter">
        <div className="filter">
          <div className="container-fluid">
            {/* Desktop: Show filters normally */}
            <div className="desktop-filter">
              <div className="d-flex flex-row-reverse flex-wrap">
                <div>
                  <AntButton type="primary" className="ml-3" onClick={handleApplyFilters}>
                    Apply
                  </AntButton>
                  <AntButton className="ml-3" onClick={handleResetFilters}>
                    Reset
                  </AntButton>
                </div>
                <div className="form-group flex-fill ms-2" style={{ marginBottom: 0 }}>
                  <div className="filter-sticky">
                    <div className="d-flex justify-content-end">
                      <AntDatePicker.RangePicker
                        value={[dayjs(filters.startDate), dayjs(filters.endDate)]}
                        onChange={(dates) => {
                          if (!dates || dates.length !== 2) return;
                          const [start, end] = dates;
                          handleChangeDate(null, { startDate: start, endDate: end });
                        }}
                        allowClear={false}
                        format="YYYY-MM-DD"
                        style={{ width: '100%' }}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex-fill ms-2" style={{ minWidth: 220 }}>
                  <AntInput
                    placeholder="Campaign Name"
                    value={filters.campaign}
                    onChange={(e) =>
                      setFilters((prev) => ({ ...prev, campaign: e.target.value }))
                    }
                  />
                </div>

                <div className="flex-fill ms-2" style={{ minWidth: 220 }}>
                  <AntSelect
                    showSearch
                    allowClear
                    placeholder="All Countries"
                    options={countryOptions}
                    value={filters.country || undefined}
                    onChange={(val) => setFilters((prev) => ({ ...prev, country: val || "" }))}
                    optionFilterProp="label"
                    style={{ width: "100%" }}
                  />
                </div>

                <div className="flex-fill ms-2" style={{ minWidth: 200 }}>
                  <AntSelect
                    allowClear
                    placeholder="All Ad Networks"
                    options={adNetworkOptions}
                    value={filters.adnetwork || undefined}
                    onChange={(val) => setFilters((prev) => ({ ...prev, adnetwork: val || "" }))}
                    style={{ width: "100%" }}
                  />
                </div>

                <div className="flex-fill ms-2" style={{ minWidth: 160 }}>
                  <AntSelect
                    allowClear
                    placeholder="All Platform"
                    options={osOptions}
                    value={filters.os || undefined}
                    onChange={(val) => setFilters((prev) => ({ ...prev, os: val || "" }))}
                    style={{ width: "100%" }}
                  />
                </div>

                {/* <Select2Custom
                    value={filters.code}
                    // options={filters.code}
                    onChange={(e) =>
                      setFilters((prev) => ({ ...prev, code: e.target.value }))
                    }
                    default="All Code"
                    placeholder="Select"
                    isMulti={true}
                    isValid={null}
                    className="flex-fill"
                /> */}

                <div className="flex-fill" style={{ minWidth: 260 }}>
                  <AntSelect
                    mode="multiple"
                    labelInValue
                    allowClear
                    placeholder="Select Apps"
                    value={filters.option}
                    onChange={(vals) => {
                      const normalized = (vals || []).map(v => ({ value: v.value, label: v.label }));
                      handleChangeApp(normalized);
                    }}
                    options={appsOptions}
                    optionLabelProp="label"
                    className="app-select"
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mobile: Drawer with filters */}
      <Drawer
        title="Search Filters"
        placement="right"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        width={320}
        className="mobile-filter-drawer"
        zIndex={2500}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <AntSelect
            mode="multiple"
            labelInValue
            allowClear
            placeholder="Select Apps"
            value={filters.option}
            onChange={(vals) => {
              const normalized = (vals || []).map(v => ({ value: v.value, label: v.label }));
              handleChangeApp(normalized);
            }}
            options={appsOptions}
            optionLabelProp="label"
            className="app-select"
            style={{ width: "100%" }}
          />

          <AntSelect
            allowClear
            placeholder="All Platform"
            options={osOptions}
            value={filters.os || undefined}
            onChange={(val) => setFilters((prev) => ({ ...prev, os: val || "" }))}
            style={{ width: "100%" }}
          />

          <AntSelect
            allowClear
            placeholder="All Ad Networks"
            options={adNetworkOptions}
            value={filters.adnetwork || undefined}
            onChange={(val) => setFilters((prev) => ({ ...prev, adnetwork: val || "" }))}
            style={{ width: "100%" }}
          />

          <AntSelect
            showSearch
            allowClear
            placeholder="All Countries"
            options={countryOptions}
            value={filters.country || undefined}
            onChange={(val) => setFilters((prev) => ({ ...prev, country: val || "" }))}
            optionFilterProp="label"
            style={{ width: "100%" }}
          />

          <AntInput
            placeholder="Campaign Name"
            value={filters.campaign}
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, campaign: e.target.value }))
            }
          />

          <div className="filter-sticky">
            <AntDatePicker.RangePicker
              value={[dayjs(filters.startDate), dayjs(filters.endDate)]}
              onChange={(dates) => {
                if (!dates || dates.length !== 2) return;
                const [start, end] = dates;
                handleChangeDate(null, { startDate: start, endDate: end });
              }}
              allowClear={false}
              format="YYYY-MM-DD"
              style={{ width: "100%" }}
              getPopupContainer={(trigger) => trigger.parentNode}
              dropdownClassName="drawer-date-dropdown"
            />
          </div>

          <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
            <button
              className="btn btn-primary"
              onClick={handleApplyFilters}
              style={{ flex: 1 }}
            >
              Apply
            </button>
            <button
              className="btn btn-secondary"
              onClick={handleResetFilters}
              style={{ flex: 1 }}
            >
              Reset
            </button>
          </div>
        </div>
      </Drawer>

      <style>{`
        /* Card selects unified width and bold text (PC & Mobile) */
        .card-select { width: 120px !important; }
        .card-select .ant-select-selection-item { font-weight: 600 !important; }

        /* Summary card styles scoped to dashboard only */
        .dashboard-scope .card-summary { display: flex; flex-direction: column; height: 100%; }
        .dashboard-scope .card-summary .money { font-weight: 700; font-size: 22px; line-height: 1.2; }
        .dashboard-scope .card-summary .fa-sort-down { color: #f5222d; margin: 0 4px; }
        .dashboard-scope .card-summary .fa-sort-up { color: #52c41a; margin: 0 4px; }
        .dashboard-scope .sumary-dash .card-summary:last-child { height: 100%; display: flex; flex-direction: column; justify-content: center; }
        .dashboard-scope p.last { margin: 15px 0 !important; }

        /* CSS cho table trong Card - áp dụng cho tất cả Card */
        .dashboard-scope .ant-card .fa-sort-up { color: #0C8F00; }
        .dashboard-scope .ant-card .fa-sort-down { color: #EE1704; }
        .dashboard-scope .ant-card .fa-sort-up::before,
        .dashboard-scope .ant-card .fa-sort-down::before {
          display: table-cell;
          line-height: 0;
        }
        .dashboard-scope .ant-card .fa-sort-down::before {
          line-height: 1;
        }
        .dashboard-scope .ant-card .flex-column .fa-sort-up::before,
        .dashboard-scope .ant-card .flex-column .fa-sort-down::before {
          line-height: 0.2;
        }
        .dashboard-scope .ant-card .flex-column .fa-sort-up.active,
        .dashboard-scope .ant-card .flex-column .fa-sort-down.active {
          color: #109CF1;
        }
        .dashboard-scope .ant-card table {
          overflow-x: scroll;
        }
        .dashboard-scope .ant-card th,
        .dashboard-scope .ant-card td {
          max-width: 300px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 300px;
        }
        .dashboard-scope .ant-card th {
          background: #F5F5F5;
        }
        .dashboard-scope .ant-card th:hover {
          background: #cbcbcb;
          cursor: pointer;
        }
        .dashboard-scope .ant-card th .fa {
          color: #B5B5C3;
          cursor: pointer;
        }
        .dashboard-scope .ant-card .fa-filter,
        .dashboard-scope .ant-card .fa-sort {
          font-size: 12px;
        }
        .dashboard-scope .ant-card .table-responsive {
          display: block;
          overflow-x: auto;
          width: 100%;
        }
        .dashboard-scope .ant-card .table-responsive .fixed {
          background: #fff;
          min-height: 200px;
          left: 0;
          position: sticky;
        }
        .dashboard-scope .ant-card .table-responsive th.fixed {
          background: #F5F5F5;
        }
        /* Mobile styles */
        @media (max-width: 768px) {
          .main__content { margin-top: 0 !important; }
          .main__filter {
            display: none !important;
          }
          .desktop-filter {
            display: none !important;
          }
          .mobile-search-toggle {
            display: block !important;
          }
          /* Drawer body padding on mobile */
          .mobile-filter-drawer .ant-drawer-body { padding: 10px !important; }
          
          /* Reset padding trong container-fluid */
          .dashboard-scope .container-fluid {
            padding-left: 15px !important;
            padding-right: 15px !important;
          }
          
          /* Reset padding của row */
          .dashboard-scope .container-fluid .row {
            margin-left: 0 !important;
            margin-right: 0 !important;
            padding-left: 0 !important;
            padding-right: 0 !important;
          }
          
          /* Fix responsive for charts on mobile - 1 column layout */
          .dashboard-scope .col-md-6,
          .dashboard-scope .col-md-3,
          .dashboard-scope .col.index-dash {
            width: 100% !important;
            max-width: 100% !important;
            flex: 0 0 100% !important;
            padding-left: 0 !important;
            padding-right: 0 !important;
            margin-top: 0 !important;
            margin-bottom: 15px !important;
          }
          
          /* Phần tử cuối cùng trong row không có margin-bottom */
          .dashboard-scope .col-md-6:last-child,
          .dashboard-scope .col-md-3:last-child,
          .dashboard-scope .col.index-dash:last-child {
            margin-bottom: 0 !important;
          }
          
          /* Khoảng cách trên dưới trong 1 row là 15px */
          .dashboard-scope .row.justify-content-between {
            width: 100% !important;
            max-width: 100% !important;
            margin-top: 15px !important;
            margin-bottom: 15px !important;
          }
          
          /* Row đầu tiên không có margin-top */
          .dashboard-scope .row.justify-content-between:first-child {
            margin-top: 0 !important;
          }
          
          /* Loại bỏ margin-bottom của row cuối */
          .dashboard-scope .row.justify-content-between:last-child {
            margin-bottom: 0 !important;
          }
          
          /* Khoảng cách giữa row đầu tiên (sumary-dash) và row tiếp theo */
          .dashboard-scope .sumary-dash {
            margin-top: 0 !important;
            margin-bottom: 15px !important;
          }
          
          /* Card styles - căn giữa với 15px mỗi bên */
          .dashboard-scope .ant-card {
            width: 100% !important;
            margin: 0 !important;
          }
          
          .box-chart {
            width: 100% !important;
            max-width: 100% !important;
            overflow: hidden;
            padding: 1rem;
          }
          .chart-data {
            width: 100% !important;
            max-width: 100% !important;
            overflow: hidden;
          }
          /* Fix chart container to fill box */
          .box-chart > div {
            width: 100% !important;
            max-width: 100% !important;
          }
          .box-chart canvas,
          .box-chart svg {
            width: 100% !important;
            max-width: 100% !important;
            height: auto !important;
          }
          /* Bold selected text in antd selects inside cards */
          .card-select .ant-select-selection-item {
            font-weight: 600 !important;
          }
          /* Ensure chart fills container */
          .box-chart .recharts-wrapper,
          .box-chart .recharts-surface {
            width: 100% !important;
            max-width: 100% !important;
          }
        }
        
        /* Desktop styles */
        @media (min-width: 769px) {
          .main__filter {
            display: block !important;
          }
          .desktop-filter {
            display: block !important;
          }
          .mobile-search-toggle {
            display: none !important;
          }
        }

        /* Force readable color in Antd selects for country */
        .dashboard-scope .ant-select-selector .ant-select-selection-item,
        .dashboard-scope .ant-select-item-option-content {
          color: #000 !important;
        }
        .dashboard-scope .ant-select-selection-placeholder { color: rgba(0,0,0,0.45) !important; }

        /* App Select: text normal */
        .dashboard-scope .app-select { width: 100% !important; }
        .dashboard-scope .app-select .ant-select-selection-item {
          font-weight: 400 !important;
        }

        /* Ensure date dropdown in Drawer doesn't overflow width */
        .mobile-filter-drawer .drawer-date-dropdown {
          max-width: 100% !important;
        }
        .mobile-filter-drawer .drawer-date-dropdown .ant-picker-panels {
          display: flex;
          flex-wrap: wrap;
        }
      `}</style>

      <section className="main__content">
        <div className="container-fluid">
          <div className="row justify-content-between sumary-dash">
            <AppSumary {...filters} reload={load} />

            <div className="col index-dash">
              <Card size="small" bodyStyle={{ padding: 16 }} style={{ width: '100%' }}>
                <div className="d-flex align-items-center h3" style={{ margin: 0 }}>
                  <AntSelect
                    size="small"
                    bordered={false}
                    className="mr-2 card-select"
                    options={FILTER_PLATFORM_COST.map(o => ({ value: o.code, label: o.name }))}
                    value={chartTypes.platformCost}
                    style={{ width: 140 }}
                    onChange={(val) =>
                      setChartTypes((prev) => ({
                        ...prev,
                        platformCost: val,
                      }))
                    }
                  />
                  by Platform
                </div>
                <div
                  className="chart-data"
                  style={{ maxHeight: "150px", width: "100%" }}
                >
                  <ChartPlatformCost
                    // key={`${JSON.stringify(filters)}-${load}`}
                    {...filters}
                    filter={chartTypes.platformCost}
                    reload={load}
                  />
                </div>
              </Card>
            </div>

            <div className="col index-dash">
              <Card size="small" bodyStyle={{ padding: 16 }} style={{ width: '100%' }}>
                <div className="d-flex align-items-center h3" style={{ margin: 0 }}>
                  <AntSelect
                    size="small"
                    bordered={false}
                    className="mr-2 card-select"
                    options={FILTER_REVENUE.map(o => ({ value: o.code, label: o.name }))}
                    value={chartTypes.platformRevenue}
                    style={{ width: 140 }}
                    onChange={(val) =>
                      setChartTypes((prev) => ({
                        ...prev,
                        platformRevenue: val,
                      }))
                    }
                  />
                  by Platform
                </div>
                <div className="chart-data" style={{ maxHeight: "150px" }}>
                  <ChartPlatformRevenue
                    // key={`${JSON.stringify(filters)}-${load}`}
                    {...filters}
                    filter={chartTypes.platformRevenue}
                    reload={load}
                  />
                </div>
              </Card>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-6" style={{ display: 'flex' }}>
              <Card size="small" bodyStyle={{ padding: 16 }} style={{ width: '100%', height: '100%' }}>
                <div className="d-flex align-items-center h3" style={{ margin: 0 }}>
                  <AntSelect
                    size="small"
                    bordered={false}
                    className="mr-2 card-select"
                    options={FILTER_ADNETWORK.map(o => ({ value: o.code, label: o.name }))}
                    value={chartTypes.typeAdnetwork}
                    onChange={(val) =>
                      setChartTypes((prev) => ({
                        ...prev,
                        typeAdnetwork: val,
                      }))
                    }
                  />
                  by Adnetwork
                </div>
                <AppNetwork
                  // key={`${JSON.stringify(filters)}-${load}`}
                  {...filters}
                  filter={chartTypes.typeAdnetwork}
                  reload={load}
                />
              </Card>
            </div>

            <div className="col-md-6" style={{ display: 'flex' }}>
              <Card size="small" bodyStyle={{ padding: 16 }} style={{ width: '100%', height: '100%' }}>
                <div className="d-flex align-items-center h3" style={{ margin: 0 }}>
                  <AntSelect
                    size="small"
                    bordered={false}
                    className="mr-2 card-select"
                    options={FILTER_ADNETWORK.map(o => ({ value: o.code, label: o.name }))}
                    value={chartTypes.campaignTargetType}
                    onChange={(val) =>
                      setChartTypes((prev) => ({
                        ...prev,
                        campaignTargetType: val,
                      }))
                    }
                  />
                  by Campaign Target Type
                </div>
                <ChartCampaignTargetType
                  // key={`${JSON.stringify(filters)}-${load}`}
                  {...filters}
                  filter={chartTypes.campaignTargetType}
                  reload={load}
                />
              </Card>
            </div>
          </div>

          {/* Campaign Performance và App Performance Tables */}
          <div className="row justify-content-between mt-6">
            <div className="col-md-6" style={{ display: 'flex' }}>
              <Card size="small" bodyStyle={{ padding: 16 }} style={{ width: '100%', height: '100%' }}>
                <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: 12 }}>
                  <p className="h3" style={{ margin: 0 }}>Campaign Performance</p>
                  <div className="d-flex align-items-center">
                    <AntSelect
                      size="small"
                      bordered={false}
                      className="card-select"
                      options={SORT_BY_OPTIONS.map(o => ({ value: o.code, label: o.name }))}
                      value={sortOptions.campaign}
                      style={{ width: 140 }}
                      onChange={(val) =>
                        setSortOptions((prev) => ({
                          ...prev,
                          campaign: val,
                        }))
                      }
                    />
                    <i className="fa fa-expand ml-3"></i>
                  </div>
                </div>
                <AppCampaignPerformance
                  // key={`${JSON.stringify(filters)}-${load}`}
                  {...filters}
                  sortValue={sortOptions.campaign}
                  reload={load}
                />
              </Card>
            </div>

            <div className="col-md-6" style={{ display: 'flex' }}>
              <Card size="small" bodyStyle={{ padding: 16 }} style={{ width: '100%', height: '100%' }}>
                <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: 12 }}>
                  <p className="h3" style={{ margin: 0 }}>App Performance</p>
                  <div className="d-flex align-items-center">
                    <AntSelect
                      size="small"
                      bordered={false}
                      className="card-select"
                      options={SORT_BY_OPTIONS.map(o => ({ value: o.code, label: o.name }))}
                      value={sortOptions.appPer}
                      style={{ width: 140 }}
                      onChange={(val) =>
                        setSortOptions((prev) => ({
                          ...prev,
                          appPer: val,
                        }))
                      }
                    />
                    <i className="fa fa-expand ml-3"></i>
                  </div>
                </div>
                <AppAppPerformance
                  // key={`${JSON.stringify(filters)}-${load}`}
                  {...filters}
                  sortValue={sortOptions.appPer}
                  reload={load}
                />
              </Card>
            </div>
          </div>

          {/* Ad Performance và Asset Performance Tables */}
          <div className="row justify-content-between mt-6">
            <div className="col-md-6">
              <Card size="small" bodyStyle={{ padding: 16 }} style={{ width: '100%' }}>
                <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: 12 }}>
                  <p className="h3" style={{ margin: 0 }}>Ad Performance</p>
                  <div className="d-flex align-items-center">
                    <AntSelect
                      size="small"
                      bordered={false}
                      className="card-select"
                      options={SORT_BY_OPTIONS.map(o => ({ value: o.code, label: o.name }))}
                      value={sortOptions.ad}
                      style={{ width: 120 }}
                      onChange={(val) =>
                        setSortOptions((prev) => ({
                          ...prev,
                          ad: val,
                        }))
                      }
                    />
                    <i className="fa fa-expand ml-3"></i>
                  </div>
                </div>
                <AppAdPerformance
                  // key={`${JSON.stringify(filters)}-${load}`}
                  {...filters}
                  sortValue={sortOptions.ad}
                  reload={load}
                />
              </Card>
            </div>

            <div className="col-md-6">
              <Card size="small" bodyStyle={{ padding: 16 }} style={{ width: '100%' }}>
                <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: 12 }}>
                  <p className="h3" style={{ margin: 0 }}>Asset Performance</p>
                  <div className="d-flex align-items-center">
                    <AntSelect
                      size="small"
                      bordered={false}
                      className="card-select"
                      options={SORT_BY_OPTIONS.map(o => ({ value: o.code, label: o.name }))}
                      value={sortOptions.assetPer}
                      style={{ width: 120 }}
                      onChange={(val) =>
                        setSortOptions((prev) => ({
                          ...prev,
                          assetPer: val,
                        }))
                      }
                    />
                    <i className="fa fa-expand ml-3"></i>
                  </div>
                </div>
                <AppAssetPerformance
                  // key={`${JSON.stringify(filters)}-${load}`}
                  {...filters}
                  sortValue={sortOptions.assetPer}
                  reload={load}
                />
              </Card>
            </div>
          </div>

          {/* Country Chart */}
          <div className="row justify-content-between mt-6">
            <div className="col-md-6">
              <Card size="small" bodyStyle={{ padding: 16 }} style={{ width: '100%' }}>
                <div className="d-flex align-items-center h3" style={{ margin: 0 }}>
                  <AntSelect
                    size="small"
                    bordered={false}
                    className="mr-2 card-select"
                    options={FILTER_ADNETWORK.map(o => ({ value: o.code, label: o.name }))}
                    value={chartTypes.country}
                    onChange={(val) =>
                      setChartTypes((prev) => ({
                        ...prev,
                        country: val,
                      }))
                    }
                  />
                  by Country
                </div>
                <div className="chart-data">
                  <ChartCountry
                    // key={`${JSON.stringify(filters)}-${load}`}
                    {...filters}
                    filter={chartTypes.country}
                    reload={load}
                  />
                </div>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Dashboard;
